import { EAuth } from '@enums/api.enum';

import client from '../apiClient';

export type AuthParams = {
	code: string;
};

export type AuthApiResponse = {
	token: string;
};

const endpoint = EAuth.endpoint;

const get = <T>({ code }: AuthParams) => {
	return client.get<T>(`${endpoint}${EAuth.code}${code}`);
};

export default {
	get,
};
